<template>
	<Image
		v-if="visible"
    	:style="{ display: 'none' }"
    	:preview="{ visible, onVisibleChange }"
      	:src="imageUrl"
    />
</template>

<script setup>
	import { Image } from 'ant-design-vue'

    // 父组件传递的参数
	const props = defineProps({
		visible: {
			type: Boolean,
			default: false,
		},
        url: {
			type: String,
			default: '',
		},
    })
    // 图片组件显示控制
	const visible = $ref(false)
	// 图片地址
	const imageUrl = $ref('')


	// 图片组件发生改变
	const onVisibleChange = (value, url) => {
		visible = value
		if (visible) {
			imageUrl = url
		} else {
			imageUrl = ''
		}
	}
    onVisibleChange(props.visible, props.url)
</script>
